import { SimpleStore } from "@core/store/store";
import { withId } from "@utils/domain";
import { DiplomaDraft } from "./diploma";
import { Track, TrackDraft, TrackLevel } from "./track";
import { TrackApi } from "./trackApi";

export class TrackService {
	trackStore = new SimpleStore((id) => this.trackApi.get(id));

	constructor(private readonly trackApi: TrackApi) {}

	async save(draft: TrackDraft, trackId: string): Promise<Track> {
		const track = await this.trackApi.save(draft, trackId);
		this.trackStore.update(trackId, () => track);
		return track;
	}

	async delete(id: string): Promise<void> {
		await this.trackApi.delete(id);
		this.trackStore.remove(id);
	}

	async saveDiploma(track: Track, levelId: string, diploma: DiplomaDraft, diplomaId?: string): Promise<void> {
		const modifiedLevel = track.levels.find((lv) => lv.id === levelId);
		if (!modifiedLevel) {
			throw Error("Trying to edit a non existing level");
		}
		const newDiplomas = diplomaId
			? modifiedLevel.diplomas.map((d) => (d.id === diplomaId ? { ...diploma, id: diplomaId } : d))
			: modifiedLevel.diplomas.push(withId(diploma));

		return this.updateLevel(track, { ...modifiedLevel, diplomas: newDiplomas });
	}

	async deleteDiploma(track: Track, levelId: string, diplomaId: string): Promise<void> {
		const modifiedLevel = track.levels.find((lv) => lv.id === levelId);
		if (!modifiedLevel) {
			throw Error("Trying to edit a non existing level");
		}
		return this.updateLevel(track, {
			...modifiedLevel,
			diplomas: modifiedLevel.diplomas.filter(({ id }) => id !== diplomaId),
		});
	}

	private async updateLevel(track: Track, newLevel: TrackLevel): Promise<void> {
		const newLevels = track.levels.map((lv) => (lv.id === newLevel.id ? newLevel : lv));
		const newTrack = await this.save({ ...track, levels: newLevels }, track.id);
		this.trackStore.update(track.id, () => newTrack);
	}
}
